import { PortableText } from '../PortableText';
import React from 'react';
import { Headline as RawHeadline } from '../../../components/landingPage/Headline';
import { SanityBlock, SanityObject } from '../../../lib/landingPage';
import { GoogleLoginProps, GoogleLogin } from '../GoogleLogin';
import { IconLabel, IconLabelProps } from '../IconLabel';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { Video, VideoProps } from '../Video';
import { Union, Wrapper } from '../Wrapper';

export type HeadlineProps = {
    titlePrefix: string;
    cyclingTexts: string[];
    titleSuffix?: string;
    description: SanityBlock;
    labels: SanityObject<IconLabelProps>[];
    video: SanityObject<VideoProps>;
    subtitle: string;
    links: SanityObject<ButtonLinkProps | GoogleLoginProps>[];
    linksDescription?: string;
};

export const Headline = Wrapper(
    ({
        titlePrefix,
        titleSuffix,
        cyclingTexts,
        description,
        labels,
        video,
        subtitle,
        links,
        linksDescription = 'Teste gratuitamente sem cartão de crédito',
    }: HeadlineProps): JSX.Element => {
        return (
            <RawHeadline
                video={<Video value={video} />}
                titlePrefix={titlePrefix}
                titleSuffix={titleSuffix}
                cyclingTexts={cyclingTexts}
                subtitle={subtitle}
                labels={<IconLabel value={labels} />}
                buttonsDescription={linksDescription}
                buttons={
                    links.every(link => React.isValidElement(link)) ? (
                        links
                    ) : (
                        <Union
                            value={links}
                            components={[GoogleLogin, ButtonLink]}
                        />
                    )
                }>
                <PortableText value={description} />
            </RawHeadline>
        );
    },
    'headline'
);
